import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "../../actions/users/getUserActions";
import { fetchActiveCategories } from "./../../actions/categories/fetchActiveCategories";
import resetSelectAllCheckbox from "../Utility/resetSelectAllCheckbox"
import { bindActionCreators } from "redux";
import { colHeaders } from "../../Constants/colHeaders";
import { Dimmer, Modal, Loader, Menu, Icon, Header, Button } from "semantic-ui-react";
import {
    createNotification,
    NOTIFICATION_TYPE_SUCCESS,
    NOTIFICATION_TYPE_WARNING,
    NOTIFICATION_TYPE_ERROR
} from "react-redux-notify";
import svg_icon_path from "../../static/media/SVGSpriteIcon.svg";
try {
    var userDetails = atob(localStorage.getItem("userDetails"));
    if (userDetails) {
        userDetails = JSON.parse(userDetails);
    }
}
catch (e) {
    window.location.reload();
}
//  let logindetails = this.getFullName(userDetails.UserContext);
var FIRM_ID = userDetails ? userDetails.UserContext.firmId : 847;
var logginedUser = userDetails.UserContext.userId;

//Check globale user
//console.log(userDetails, userDetails.Rights);
let rightsDetails = userDetails.Rights.filter(x => x.module_id == 8);
let BRANCH_ID = userDetails.UserContext.locationId;
let RIGHT_ACCESS = rightsDetails[0].access;
let MODULE_ID = rightsDetails[0].module_id;
let GLOBAL_USER = "N";
if (RIGHT_ACCESS == 1 && MODULE_ID == 8) {
    GLOBAL_USER = "Y";
}


class UserPageActions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            load: false,
            phasetwoStarted: false
        };
    }
    renderRedirect = () => {
        this.props.history.push("/createuser");
    };
    clearFilters() {
        //isClearFilters
        // console.log("allUsers", this)
        this.props.actions.clearAllFilters(true, this.props.allUsers);

    }
    showLoader(load) {
        return (
            <Dimmer page active={load} inverted>
                <Loader inverted>Loading</Loader>
            </Dimmer>
        );
    }
    refreshGridData() {

        // console.log("refreshGridData")
        this.setState({ load: true })
        resetSelectAllCheckbox();
        this.props.fetchActiveCategories(FIRM_ID).then((res) => {
            this.props.actions.getAllUsers(
                FIRM_ID,
                BRANCH_ID,
                GLOBAL_USER,
                this.props.lookup,
                res.payload.categoryData
            ).then(() => {
                const mySuccessNotification = {
                    message: "Grid successfully refreshed",
                    type: NOTIFICATION_TYPE_SUCCESS,
                    duration: 5000,
                    canDismiss: true,
                    showCloseAllBtn: true
                };
                this.setState({ load: false })
                this.props.createNotification(mySuccessNotification);
            });
        });
        //isRefresh, userFilterStatus, isEdited, isClearFilters set 
        //this.props.actions.refetchGridData(true, true, false);
    }
    exportToExcel() {
        let isExport = true;
        //console.log("actions : ", this.props.actions);
        this.props.actions.exportToExcel(isExport);
    }


    componentDidMount() {
        this.props.actions.fetchfirmLookUpDetails(FIRM_ID).then((res) => {
            this.validateStaffIntegration();
        });
    }

    validateStaffIntegration() {
        if (this.props.firmLookUpDetails.axcessIntegrationEnabled == true && this.props.firmLookUpDetails.axcessIntegrationDate != null) {
            var lastDate = new Date(this.props.firmLookUpDetails.axcessIntegrationDate);
            var gracePeriod = this.props.firmLookUpDetails.axcessIntegrationGracePeriod;
            lastDate.setDate(lastDate.getDate() + gracePeriod);
            if (gracePeriod == 0) {
                this.setState({ phasetwoStarted: true });
            }
            else if (lastDate.getTime() < new Date().getTime()) {
                this.setState({ phasetwoStarted: true });
            }
        }
    }

    render() {

        console.log("#############################", this.props.allUsers.length)
        return (
            <Fragment>
                {this.showLoader(this.state.load)}
                <Menu secondary className={this.props.reqClass}>
                    <Menu.Item>
                        <Header as="h3" className="uppercase"> Manage Users - {this.props.rowsCount ? this.props.rowsCount : 0} <span className="lowercase">of</span> {this.props.allUsers.length} </Header>
                    </Menu.Item>

                    <Menu.Menu position="right">
                        <Menu.Item>
                            <span>
                                <label>License Count: </label>
                                <b>{this.props.lookup ? this.props.lookup.LicenseCount : 0}</b>
                            </span>
                        </Menu.Item>
                        <Menu.Item>
                            |
            </Menu.Item>
                        <Menu.Item>
                            <span>
                                <label>Active Users: </label>
                                <b>{this.props.lookup ? this.props.lookup.ActiveUsersCount : 0}</b>
                            </span>
                        </Menu.Item>
                        {this.props.rowsCount != this.props.allUsers.length ? (
                            <Menu.Item>
                                <svg className={`svg_icon xcm-icon-filter-clear size-24`} onClick={this.clearFilters.bind(this)}>
                                    <title> Clear Filters </title>
                                    <use xlinkHref={`${svg_icon_path}#xcm-icon-filter-clear`}> </use>
                                </svg>
                            </Menu.Item>
                        ) : ("")}
                        <Menu.Item>
                            <svg className={`svg_icon xcm-icon-refresh size-24`} onClick={this.refreshGridData.bind(this)}>
                                <title> Refresh Grid Data </title>
                                <use xlinkHref={`${svg_icon_path}#xcm-icon-refresh`}> </use>
                            </svg>
                        </Menu.Item>
                        {/* <Menu.Item> <Icon className="xcm-icon-sort-column" size="big" /> </Menu.Item>  */}
                        <Menu.Item>
                            <svg className={`svg_icon xcm-icon-export-excel size-24`} onClick={this.exportToExcel.bind(this)}>
                                <title> Export to Excel </title>
                                <use xlinkHref={`${svg_icon_path}#xcm-icon-export-excel`}> </use>
                            </svg>
                        </Menu.Item>
                        {(this.props.lookup.LicenseCount > this.props.lookup.ActiveUsersCount) && !this.state.phasetwoStarted ? (
                            <Menu.Item>
                                <Button className="uppercase bold" primary onClick={() => this.renderRedirect()}>
                                    <Icon
                                        name="plus" /> Add New User
                </Button>
                            </Menu.Item>
                        ) :
                            (
                                <Menu.Item>
                                    <span className="z-index-1000" data-position="bottom right" data-tooltip={this.state.phasetwoStarted ? "Staff Integration has completed. Note: New users can only be added using CCH Axcess Staff Manager." :
                                        "Active users count has reached the Licensed users count"} data-tooltip-disable={false}>
                                        <Button disabled className="uppercase bold">
                                            <Icon
                                                name="plus" /> Add New User
                </Button>
                                    </span>
                                </Menu.Item>
                            )}
                    </Menu.Menu>
                </Menu>
            </Fragment >
        );
    }
}

const mapStateToProps = state => {
    return {
        isExport: state.userReducer.isExport,
        isEdited: state.userReducer.isEdited,
        // isRefresh: state.userReducer.isRefresh,
        isClearFilters: state.userReducer.isClearFilters,
        //showFilterIcon: state.userReducer.showFilterIcon,
        allUsers: state.userReducer.allUsers,
        lookup: state.userReducer.lookupData,
        rowsCount: state.userReducer.rowsCount,
        categories: state.allCategories.activeCategories,
        firmLookUpDetails: state.userReducer.firmLookUpDetails
    };
};

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(actions, dispatch),
    createNotification: config => {
        dispatch(createNotification(config));
    },
    fetchActiveCategories: () => dispatch(fetchActiveCategories(FIRM_ID))
});

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(UserPageActions)
);
